module.exports = __webpack_public_path__ + "media/images/logo-83fce1ddff11c5062ceb5b3dfcb4d837.svg";